import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { IntroductionEffects, introductionReducer } from './store';

@NgModule({
  imports: [
    EffectsModule.forFeature([IntroductionEffects]),
    StoreModule.forFeature(`introduction`, introductionReducer)
  ]
})
export class IntroductionStateModule {}
